import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { api } from "../lib/api";

export const Gallery = () => {
  const [images, setImages] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get(`/gallery`).then((r) => setImages(r.data)).catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-28 bg-secondary/40">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-12 max-w-2xl">
          <div className="font-mono-ui text-xs uppercase tracking-widest text-accent mb-3">
            — 04 / The Field
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight leading-tight">
            Where our food comes from.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {images.map((img, i) => (
            <button
              key={img.id}
              data-testid={`gallery-item-${img.id}`}
              onClick={() => setActive(img)}
              className={`relative group overflow-hidden rounded-xl bg-muted ${
                i % 5 === 0 ? "md:row-span-2 aspect-[3/4] md:aspect-auto" : "aspect-square"
              }`}
            >
              <img
                src={img.src}
                alt={img.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-primary-foreground font-display text-sm">
                  {img.caption}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent data-testid="gallery-dialog" className="max-w-3xl p-0 overflow-hidden bg-background">
          {active && (
            <div>
              <img src={active.src} alt={active.caption} className="w-full max-h-[75vh] object-contain bg-primary" />
              <div className="p-5">
                <div className="font-display text-lg">{active.caption}</div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
